define("shared/components/shared/address-fields/item", ["exports", "@ember/component", "@ember/object", "@ember/service", "@ember/utils", "@glimmer/component", "@glimmer/tracking", "shared/utils/uuid", "@ember/template-factory"], function (_exports, _component, _object, _service, _utils, _component2, _tracking, _uuid, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@ember/utils",0,"@glimmer/component",0,"@glimmer/tracking",0,"shared/utils/uuid",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#if this.useStateDropdown}}
    <PowerSelect
      @destination={{this.dropdownId}}
      @disabled={{@isDisabled}}
      @matchTriggerWidth={{false}}
      @onChange={{this.updateSelectedState}}
      @options={{this.stateFieldOptions}}
      @placeholder={{@placeHolder}}
      @renderInPlace={{false}}
      @searchEnabled={{true}}
      @searchField="name"
      @searchPlaceholder={{t "shared_words.search"}}
      @selected={{this.selectedStateOption}}
      class={{concat-classes
        @qaClass
        (if (or this.showEmptyError (and @showSuggestion (is-present this.suggestion))) "ember-basic-dropdown--hasError")
        (if @isDisabled "u--mute")
      }}
      data-test-id="address-form-item"
      as |option|
    >
      {{option.name}}
    </PowerSelect>
    {{! TODO: figure out placement/layout bug }}
    <div id={{this.dropdownId}}></div>
  {{else}}
    <Input
      @type="text"
      @value={{@value}}
      class={{concat-classes
        "o--form__input"
        @qaClass
        (if (or this.showEmptyError (and @showSuggestion (is-present this.suggestion))) "o--form__input--hasError")
        (if @isDisabled "u--mute")
      }}
      data-test-id="address-form-item"
      disabled={{@isDisabled}}
      placeholder={{@placeHolder}}
      {{on "change" this.clearSuggestion}}
      {{on "keyup" this.clearSuggestion}}
    />
  {{/if}}
  
  {{! @glint-expect-error: Shared::AddressFields::Error }}
  <Shared::AddressFields::Error
    @emptyText={{@emptyText}}
    @field={{@field}}
    @invalidText={{@invalidText}}
    @missingValue={{this.showEmptyError}}
    @setSuggestion={{@setSuggestion}}
    @showSuggestion={{@showSuggestion}}
    @suggestion={{this.suggestion}}
  />
  */
  {
    "id": "+teYEdai",
    "block": "[[[41,[30,0,[\"useStateDropdown\"]],[[[1,\"  \"],[8,[39,1],[[16,0,[28,[37,2],[[30,1],[52,[28,[37,3],[[30,0,[\"showEmptyError\"]],[28,[37,4],[[30,2],[28,[37,5],[[30,0,[\"suggestion\"]]],null]],null]],null],\"ember-basic-dropdown--hasError\"],[52,[30,3],\"u--mute\"]],null]],[24,\"data-test-id\",\"address-form-item\"]],[[\"@destination\",\"@disabled\",\"@matchTriggerWidth\",\"@onChange\",\"@options\",\"@placeholder\",\"@renderInPlace\",\"@searchEnabled\",\"@searchField\",\"@searchPlaceholder\",\"@selected\"],[[30,0,[\"dropdownId\"]],[30,3],false,[30,0,[\"updateSelectedState\"]],[30,0,[\"stateFieldOptions\"]],[30,4],false,true,\"name\",[28,[37,6],[\"shared_words.search\"],null],[30,0,[\"selectedStateOption\"]]]],[[\"default\"],[[[[1,\"\\n    \"],[1,[30,5,[\"name\"]]],[1,\"\\n  \"]],[5]]]]],[1,\"\\n\"],[1,\"  \"],[10,0],[15,1,[30,0,[\"dropdownId\"]]],[12],[13],[1,\"\\n\"]],[]],[[[1,\"  \"],[8,[39,7],[[16,0,[28,[37,2],[\"o--form__input\",[30,1],[52,[28,[37,3],[[30,0,[\"showEmptyError\"]],[28,[37,4],[[30,2],[28,[37,5],[[30,0,[\"suggestion\"]]],null]],null]],null],\"o--form__input--hasError\"],[52,[30,3],\"u--mute\"]],null]],[24,\"data-test-id\",\"address-form-item\"],[16,\"disabled\",[30,3]],[16,\"placeholder\",[30,4]],[4,[38,8],[\"change\",[30,0,[\"clearSuggestion\"]]],null],[4,[38,8],[\"keyup\",[30,0,[\"clearSuggestion\"]]],null]],[[\"@type\",\"@value\"],[\"text\",[30,6]]],null],[1,\"\\n\"]],[]]],[1,\"\\n\"],[8,[39,9],null,[[\"@emptyText\",\"@field\",\"@invalidText\",\"@missingValue\",\"@setSuggestion\",\"@showSuggestion\",\"@suggestion\"],[[30,7],[30,8],[30,9],[30,0,[\"showEmptyError\"]],[30,10],[30,2],[30,0,[\"suggestion\"]]]],null]],[\"@qaClass\",\"@showSuggestion\",\"@isDisabled\",\"@placeHolder\",\"option\",\"@value\",\"@emptyText\",\"@field\",\"@invalidText\",\"@setSuggestion\"],false,[\"if\",\"power-select\",\"concat-classes\",\"or\",\"and\",\"is-present\",\"t\",\"input\",\"on\",\"shared/address-fields/error\"]]",
    "moduleName": "shared/components/shared/address-fields/item.hbs",
    "isStrictMode": false
  });
  let AddressItemComponent = _exports.default = (_class = class AddressItemComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);
      _initializerDefineProperty(this, "uid", _descriptor, this);
      _initializerDefineProperty(this, "address", _descriptor2, this);
      this.uid = (0, _uuid.default)();
    }
    get useStateDropdown() {
      if (!this.args.country || this.args.field !== 'state') {
        return false;
      }
      return this.stateFieldOptions.length > 0;
    }
    get showEmptyError() {
      return Boolean(this.args.isRequired) && this.args.showErrors && !(0, _utils.isPresent)(this.args.value);
    }
    get suggestion() {
      return this.address.suggestedChanges.find(item => item.key === this.args.field);
    }
    get stateFieldOptions() {
      if (!this.args.country || this.args.field !== 'state') {
        return [];
      }
      return this.address.getStateFieldOptions(this.args.country);
    }
    get selectedStateOption() {
      return this.stateFieldOptions.find(option => option.value === this.args.value);
    }
    get dropdownId() {
      return `${this.args.field}_dropdown-${this.uid}`;
    }
    updateSelectedState(option) {
      this.args.setSelectedState?.(option.value);
    }
    clearSuggestion() {
      this.address.resetValidation();
      if ((0, _utils.isPresent)(this.suggestion)) {
        this.address.clearSuggestion(this.args.field);
      }
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "uid", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "address", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "updateSelectedState", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateSelectedState"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clearSuggestion", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "clearSuggestion"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, AddressItemComponent);
});